module.exports = __webpack_public_path__ + "img/img-jili-fish.15595c70.png";